export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts?.length === 2) {
    const cookieValue = parts[1].split(';')[0];
    return cookieValue || null;
  }
  return null; // Return null if the cookie is not found
};
